<template>
  <div class="mobile-menu">
    <a-menu mode="inline">
      <!-- 儀表板 -->
      <a-menu-item
        key="dashboard"
        @click="handleMenuClick('/dashboard')"
        :class="{ 'ant-menu-item-selected': $route.path === '/dashboard' }"
      >
        <template #icon>
          <svg
            class="menu-icon-svg"
            viewBox="0 0 19 19"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.33333 2.5V5.83333C8.33333 6.49638 8.06994 7.13226 7.6011 7.6011C7.13226 8.06994 6.49638 8.33333 5.83333 8.33333H2.5C1.83696 8.33333 1.20107 8.06994 0.732233 7.6011C0.263392 7.13226 0 6.49638 0 5.83333V2.5C0 1.83696 0.263392 1.20107 0.732233 0.732233C1.20107 0.263392 1.83696 0 2.5 0H5.83333C6.49638 0 7.13226 0.263392 7.6011 0.732233C8.06994 1.20107 8.33333 1.83696 8.33333 2.5ZM15.8333 0H12.5C11.837 0 11.2011 0.263392 10.7322 0.732233C10.2634 1.20107 10 1.83696 10 2.5V5.83333C10 6.49638 10.2634 7.13226 10.7322 7.6011C11.2011 8.06994 11.837 8.33333 12.5 8.33333H15.8333C16.4964 8.33333 17.1323 8.06994 17.6011 7.6011C18.0699 7.13226 18.3333 6.49638 18.3333 5.83333V2.5C18.3333 1.83696 18.0699 1.20107 17.6011 0.732233C17.1323 0.263392 16.4964 0 15.8333 0ZM5.83333 10H2.5C1.83696 10 1.20107 10.2634 0.732233 10.7322C0.263392 11.2011 0 11.837 0 12.5V15.8333C0 16.4964 0.263392 17.1323 0.732233 17.6011C1.20107 18.0699 1.83696 18.3333 2.5 18.3333H5.83333C6.49638 18.3333 7.13226 18.0699 7.6011 17.6011C8.06994 17.1323 8.33333 16.4964 8.33333 15.8333V12.5C8.33333 11.837 8.06994 11.2011 7.6011 10.7322C7.13226 10.2634 6.49638 10 5.83333 10ZM15.8333 10H12.5C11.837 10 11.2011 10.2634 10.7322 10.7322C10.2634 11.2011 10 11.837 10 12.5V15.8333C10 16.4964 10.2634 17.1323 10.7322 17.6011C11.2011 18.0699 11.837 18.3333 12.5 18.3333H15.8333C16.4964 18.3333 17.1323 18.0699 17.6011 17.6011C18.0699 17.1323 18.3333 16.4964 18.3333 15.8333V12.5C18.3333 11.837 18.0699 11.2011 17.6011 10.7322C17.1323 10.2634 16.4964 10 15.8333 10Z"
            />
          </svg>
        </template>
        {{ $t("sidebar.dashboard") }}
      </a-menu-item>

      <!-- 證書下載 / 修課證明下載 -->
      <a-menu-item
        key="certificates"
        @click="handleMenuClick('/Certificate')"
        :class="{ 'ant-menu-item-selected': $route.path.toLowerCase() === '/certificate' }"
      >
        <template #icon>
          <svg
            class="menu-icon-svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.9577 14.8666V7.39997C18.9576 7.31831 18.9413 7.23749 18.9097 7.16217C18.8782 7.08686 18.832 7.01855 18.7739 6.9612C18.7158 6.90385 18.6468 6.8586 18.5711 6.82806C18.4954 6.79752 18.4143 6.78231 18.3327 6.7833H11.0077C10.8078 6.78301 10.6122 6.72559 10.4439 6.61781C10.2756 6.51003 10.1416 6.35638 10.0577 6.17497L9.68268 5.34997L9.17435 4.24997C9.14979 4.19825 9.12195 4.14815 9.09102 4.09997C8.8952 3.74083 8.60597 3.44127 8.25392 3.23297C7.90187 3.02467 7.50007 2.91538 7.09102 2.91664H3.33268C3.03168 2.91642 2.73358 2.97554 2.45544 3.09063C2.1773 3.20572 1.92459 3.37452 1.71174 3.58736C1.4989 3.80021 1.3301 4.05292 1.21501 4.33106C1.09992 4.6092 1.0408 4.9073 1.04102 5.2083V14.8666C1.0408 15.1676 1.09992 15.4657 1.21501 15.7439C1.3301 16.022 1.4989 16.2747 1.71174 16.4876C1.92459 16.7004 2.1773 16.8692 2.45544 16.9843C2.73358 17.0994 3.03168 17.1585 3.33268 17.1583H16.666C16.967 17.1585 17.2651 17.0994 17.5433 16.9843C17.8214 16.8692 18.0741 16.7004 18.287 16.4876C18.4998 16.2747 18.6686 16.022 18.7837 15.7439C18.8988 15.4657 18.9579 15.1676 18.9577 14.8666Z"
            />
            <path
              d="M10.8171 5.83331C10.8354 5.86834 10.8629 5.89771 10.8967 5.91827C10.9305 5.93882 10.9692 5.94978 11.0087 5.94998H18.3337C18.5404 5.94787 18.7451 5.99051 18.9337 6.07498C18.8574 5.52786 18.586 5.02674 18.1695 4.66384C17.753 4.30094 17.2195 4.1007 16.6671 4.09998H10.0254L10.4421 4.99998L10.8171 5.83331Z"
            />
          </svg>
        </template>
        {{ $t("sidebar.certificates") }}
      </a-menu-item>

      <!-- 收藏課程 -->
      <a-menu-item
        key="favorites"
        @click="handleMenuClick('/favorites')"
        :class="{ 'ant-menu-item-selected': $route.path === '/favorites' }"
      >
        <template #icon>
          <svg
            class="menu-icon-svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 2C3.89543 2 3 2.89543 3 4V18.5C3 18.8956 3.44772 19.1226 3.76822 18.8914L10 14.3914L16.2318 18.8914C16.5523 19.1226 17 18.8956 17 18.5V4C17 2.89543 16.1046 2 15 2H5Z"
            />
          </svg>
        </template>
        {{ $t("sidebar.favoriteCourses") }}
      </a-menu-item>

      <!-- 個人資訊與登出 -->
      <a-menu-item
        key="profile"
        @click="handleMenuClick('/ProfileEdit')"
        :class="{ 'ant-menu-item-selected': $route.path === '/ProfileEdit' }"
      >
        <template #icon><UserOutlined /></template>
        {{ $t("sidebar.profile") }}
      </a-menu-item>
      <a-menu-item key="logout" @click="handleLogout">
        <template #icon><LogoutOutlined /></template>
        {{ $t("navbar.logout") }}
      </a-menu-item>
      <a-menu-item
        key="home"
        @click="handleMenuClick('/home')"
        :class="{ 'ant-menu-item-selected': $route.path === '/home' || $route.path === '/' }"
      >
        <template #icon><HomeOutlined /></template>
        {{ $t("navbar.home") }}
      </a-menu-item>
    </a-menu>
  </div>
</template>

<script setup>
import { useRouter, useRoute } from "vue-router";
import { message } from "ant-design-vue";
import {
  UserOutlined,
  LogoutOutlined,
  HomeOutlined,
} from "@ant-design/icons-vue";

const router = useRouter();
const route = useRoute();

// Props
defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
});

// Emits
const emit = defineEmits(["update:isOpen", "menu-click"]);

// 處理選單點擊
const handleMenuClick = (path) => {
  router.push(path);
  emit("update:isOpen", false);
  emit("menu-click", path);
};

// 處理登出
const handleLogout = () => {
  // 清除 sessionStorage
  localStorage.removeItem("ms_platform_token");
  sessionStorage.removeItem("user_data");

  emit("update:isOpen", false);
  message.success("已成功登出");

  // 重定向到首頁
  window.location.href = "/home";
};
</script>

<style scoped>
.mobile-menu {
  position: fixed;
  top: 60px;
  left: 0;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 99;
  padding-bottom: 16px;
  max-height: calc(100vh - 60px);
  overflow-y: auto;
}

.menu-icon-svg {
  width: 16px;
  height: 16px;
  display: inline-block;
  vertical-align: -2px;
  margin-right: 8px;
}

.mobile-menu .ant-menu-item svg {
  fill: #333;
}

.mobile-menu .ant-menu-item.ant-menu-item-selected svg {
  fill: #0068a8;
}

.mobile-menu .ant-menu-item.ant-menu-item-selected {
  color: #0068a8;
}

/* 響應式設計 */
@media (max-width: 768px) {
  .mobile-content {
    margin-left: 0;
    padding-top: 80px;
  }
}
</style>
